<template>
  <div class="bz-modal-scrim" @click="$emit('decline')">
    <div class="bz-modal" role="dialog" aria-modal="true" @click.stop>
      <div class="bz-modal-h">
        <span class="bz-modal-icn"><i class="material-icons" style="font-size:20px;line-height:1;">add_business</i></span>
        <div>
          <h2>{{ toIFP ? 'Add the matching Industry Financial Profile?' : 'Add the matching Industry Market Profile?' }}</h2>
          <p class="bz-modal-sub">
            <template v-if="toIFP">Financial benchmarks — income statement, balance sheet &amp; 36 ratios — are also available for this exact selection.</template>
            <template v-else>Local competitors, market volume &amp; demographics are also available for this exact selection — carried over as-is, no extra options needed.</template>
          </p>
        </div>
        <button class="bz-upsell-x" type="button" title="Dismiss" @click="$emit('decline')">
          <i class="material-icons" style="font-size:17px;line-height:1;">close</i>
        </button>
      </div>

      <div class="bz-carry">
        <div class="bz-carry-row">
          <i class="material-icons" style="font-size:15px;line-height:1;color:var(--bzc-good);">check</i>
          <span class="bz-carry-k">Industry</span>
          <b>{{ selection.industry.name }}</b>
          <code class="bz-code">{{ selection.industry.code }}</code>
        </div>
        <div class="bz-carry-row">
          <i class="material-icons" style="font-size:15px;line-height:1;color:var(--bzc-good);">check</i>
          <span class="bz-carry-k">Market Area</span>
          <b>{{ selection.area.label }}</b>
          <span class="bz-carry-note">carried over</span>
        </div>
        <div v-if="toIFP" class="bz-carry-row bands">
          <i class="material-icons" style="font-size:15px;line-height:1;color:var(--bzc-warn);">paid</i>
          <span class="bz-carry-k">Sales Class</span>
          <div class="bz-upsell-bands">
            <button v-for="sc in bands" :key="sc.id" type="button"
              class="bz-band" :class="{ on: band === sc.id }" @click="band = sc.id">{{ sc.label }}</button>
          </div>
        </div>
        <div v-if="toIFP" class="bz-carry-row">
          <i class="material-icons" style="font-size:15px;line-height:1;color:var(--bzc-faint);">tune</i>
          <span class="bz-carry-k">Defaults</span>
          <span class="bz-carry-note">Industry Firms · 5 Years Profile — editable later</span>
        </div>
      </div>

      <div v-if="toIFP" class="bz-modal-hint">
        {{ bands.length }} of 15 sales classes are offered for <code>{{ selection.industry.code }}</code> — pick one to add the IFP.
      </div>

      <div class="bz-modal-foot">
        <button class="bz-btn ghost" type="button" @click="$emit('decline')">No thanks — continue</button>
        <button class="bz-btn primary" type="button" :disabled="toIFP && !band" @click="$emit('accept', band)">
          <template v-if="toIFP">Add IFP{{ band ? ' · ' + bandLabel : '' }} &amp; continue</template>
          <template v-else>Add IMP &amp; continue</template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Post-Access cross-sell modal. IMP→IFP collects the one missing field (sales
// class) from the industry's REAL offered bands — the caller passes them in
// from the same /info/sales_classes response that proved coverage.
import { SALES_BY_ID } from './model';

export default {
  name: 'upsell-modal',
  props: {
    product: { type: String, required: true }, // page the user is ON
    selection: { type: Object, required: true },
    offeredBands: { type: Array, default: () => [] }, // [{id,label}] — IMP→IFP only
  },
  data() {
    return { band: null };
  },
  computed: {
    toIFP() {
      return this.product === 'IMP';
    },
    bands() {
      // selectable = the offered leaf/named bands, keeping catalog order
      return this.offeredBands;
    },
    bandLabel() {
      return this.band && SALES_BY_ID[this.band] ? SALES_BY_ID[this.band].label : '';
    },
  },
};
</script>
